import { FormProps } from '@deltek/specification-client/core/Models/formProps'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import clsx from 'clsx'
import React from 'react'
import { ProductListingDetailFormField } from '../ListingDetailsPage'

const useStyles = makeStyles((theme: Theme) => ({
    container: { paddingTop: theme.spacing(2) },
    inputRoot: {
        borderRadius: 4,
    },
    input: {
        fontSize: pxToRem(36),
        fontWeight: 500,
        color: '#211F20',
    },
}))

interface EditNameProps extends FormProps {
    handleFieldChange: (
        field: ProductListingDetailFormField,
        value: string
    ) => void
    isDuplicate?: boolean
}

export const EditName: React.FC<EditNameProps> = ({
    value,
    valid,
    required,
    isDuplicate,
    handleFieldChange,
}) => {
    const classes = useStyles()

    const [localValue, setLocalValue] = React.useState<string>(value ?? '')

    const debouncedInput = React.useCallback(
        (value: string) => {
            setLocalValue(value)
            handleFieldChange('name', value)
        },
        [handleFieldChange]
    )

    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        debouncedInput(event.target.value)
    }

    return (
        <div className={classes.container}>
            <TextField
                id="name"
                data-testid="dvName"
                name="name"
                variant="outlined"
                margin="dense"
                placeholder="Product Name"
                required={required}
                fullWidth
                inputProps={{
                    maxLength: 200,
                    isduplicate: `${isDuplicate}`,
                }}
                InputProps={{
                    classes: {
                        root: clsx(valid && classes.inputRoot),
                        input: classes.input,
                    },
                }}
                value={localValue}
                onChange={handleChange}
                error={!valid}
                helperText={!valid ? 'Required' : ''}
                autoComplete="off"
            />
        </div>
    )
}
